import { AppText } from "@toothfairy/shared-ui";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppSlider from "@toothfairy/shared-ui/AppSlider";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import authorisationsHelper from "../../../../../API/Authorisations/authorisationsHelper";
import connectionsHelper from "../../../../../API/Connections/connectionsHelper";
import ToothFairyLoadingPlaceholder from "../../../../../Components/ToothFairyComponents/ToothFairyLoadingPlaceholder";
import Constants from "../../../../../Constants";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import { useHistory } from "../../../../../Router";
import QaHiringResourcesLeaf from "./QaHiringResourcesLeaf";
import QaHiringSecretLeaf from "./QaHiringSecretLeaf";
import ToothFairyButton from "../../../../../Components/ToothFairyComponents/ToothFairyButton";
const QaHiringTemplateView = ({
  agentHiringTemplate,
  handleTick,
  excludedResources,
}) => {
  const AppToasty = AppToast.useToast();
  const { setFieldValue, values } = AppForms.useFormikContext();
  const [sliderIndex, setSliderIndex] = useState(1);
  const { currentTheme } = AppTheme.useTheme();
  const history = useHistory();
  const { getActiveWorkspace } = useWorkspaces();
  const fields = agentHiringTemplate?.fields;
  const resources = agentHiringTemplate?.resources;
  const [availableAuthorisations, setAvailableAuthorisations] = useState([]);
  const [availableConnections, setAvailableConnections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const handleIndicatorClick = (index) => {
    if (index == 2) {
      // check all 3 fields are filled in in the values JSON
      if (
        Object.values(values).filter(
          (value) => value == null || value == "[object Object]"
        ).length > 0
      ) {
        AppToasty.show("Please fill in all fields before moving forward", {
          type: "danger",
        });
        return;
        // return false;
      }
    }
    setSliderIndex(index);
  };
  const fetchAuthorisations = async () => {
    const authorisations = await authorisationsHelper.getAuthorisations(
      getActiveWorkspace()?.id
    );
    const _auth =
      authorisations?.data?.authorisationsByWorkspace?.items?.filter(
        (u) => u?._deleted != true
      ) || [];
    setAvailableAuthorisations(_auth);
  };
  const fetchConnections = async () => {
    const connections = await connectionsHelper.getDatabaseConnections(
      getActiveWorkspace()?.id
    );
    const _conn =
      connections?.data?.connectionsByWorkspace?.items?.filter(
        (u) => u?._deleted != true
      ) || [];
    setAvailableConnections(_conn);
  };
  useEffect(() => {
    try {
      setIsLoading(true);
      if (getActiveWorkspace()?.id) {
        fetchAuthorisations();
        fetchConnections();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [getActiveWorkspace()?.id]);
  const renderFormField = (field, isRecap = false) => {
    if (field.type === "authorisation") {
      return (
        <QaHiringSecretLeaf
          options={availableAuthorisations}
          field={field}
          fetchOptions={fetchAuthorisations}
          isRecap={isRecap}
          type={"authorisations/"}
        />
      );
    } else if (field.type === "connection") {
      return (
        <QaHiringSecretLeaf
          options={availableConnections}
          field={field}
          fetchOptions={fetchConnections}
          isRecap={isRecap}
          type={"db_connections/"}
        />
      );
    } else {
      return <></>;
    }
  };

  const sliderItems = [
    <View
      style={{
        height: "auto",
        width: 575,
        marginTop: 20,
      }}
    >
      <AppText
        wrapperStyle={{
          marginBottom: 20,
          marginLeft: 10,
        }}
        style={{
          fontSize: 20,
          fontWeight: "bold",
        }}
        color={currentTheme?.theme?.primary}
      >
        Setup secrets
      </AppText>

      {fields?.map((u) => {
        return renderFormField(u);
      })}
      <ToothFairyButton
        wrapperStyle={{
          alignSelf: "center",
        }}
        onPress={() => handleIndicatorClick(2)}
        title={"Next"}
      />
    </View>,
    <View
      style={{
        flexDirection: "column",
        gap: 10,
        padding: 10,
      }}
    >
      <AppText
        wrapperStyle={{
          marginBottom: 20,
          marginLeft: 10,
        }}
        style={{
          fontSize: 20,
          fontWeight: "bold",
        }}
        color={currentTheme?.theme?.orange}
      >
        Import functions and resources
      </AppText>
      {resources?.dataSources?.length > 0 && (
        <>
          <QaHiringResourcesLeaf
            title={"Data sources"}
            iconTitle={"data"}
            resources={resources?.dataSources}
            excludedResources={excludedResources}
            onTick={handleTick}
          />
          <View
            style={{
              height: 1,
              backgroundColor: currentTheme?.theme?.mediumGrey,
              marginVertical: 10,
            }}
          />
        </>
      )}
      {resources?.executionEnvironments?.length > 0 && (
        <>
          <QaHiringResourcesLeaf
            title={"Execution environments"}
            iconTitle={"data"}
            resources={resources?.executionEnvironments}
            excludedResources={excludedResources}
            onTick={handleTick}
          />
          <View
            style={{
              height: 1,
              backgroundColor: currentTheme?.theme?.mediumGrey,
              marginVertical: 10,
            }}
          />
        </>
      )}
      {resources?.functions?.length > 0 && (
        <QaHiringResourcesLeaf
          title={"Functions"}
          iconTitle={"functions"}
          resources={resources?.functions}
          excludedResources={excludedResources}
          onTick={handleTick}
        />
      )}

      {excludedResources?.length > 0 && (
        <AppText
          wrapperStyle={{
            marginLeft: 10,
          }}
          color={currentTheme?.theme?.red}
        >
          When resources are not imported the agent might not operate correctly.
          Please ensure the agent is assigned the necessary resources after the
          creation with existing functions or create new ones.
        </AppText>
      )}
      <ToothFairyButton
        wrapperStyle={{
          alignSelf: "center",
        }}
        onPress={() => handleIndicatorClick(3)}
        title={"Next"}
      />
    </View>,
    <View>
      <AppText
        wrapperStyle={{
          marginBottom: 20,
          marginLeft: 10,
        }}
        style={{
          fontSize: 20,
          fontWeight: "bold",
        }}
        // color={currentTheme?.theme?.orange}
      >
        Confirm setup
      </AppText>
      <AppText
        style={{
          fontWeight: "bold",
          // fontSize: currentTheme?.theme?.large_font_size,
          marginLeft: 10,
        }}
        color={currentTheme?.theme?.primary}
        wrapperStyle={{
          marginBottom: 10,
        }}
      >
        Secrets
      </AppText>
      {fields?.map((u) => {
        return renderFormField(u, true);
      })}
      <View
        style={{
          height: 1,
          backgroundColor: currentTheme?.theme?.mediumGrey,
          marginVertical: 10,
        }}
      />
      {resources?.dataSources?.length > 0 && (
        <>
          <QaHiringResourcesLeaf
            title={"Data sources"}
            iconTitle={"data"}
            resources={resources?.dataSources}
            excludedResources={excludedResources}
            isRecap={true}
          />
          <View
            style={{
              height: 1,
              backgroundColor: currentTheme?.theme?.mediumGrey,
              marginVertical: 10,
            }}
          />
        </>
      )}
      {resources?.executionEnvironments?.length > 0 && (
        <>
          <QaHiringResourcesLeaf
            title={"Execution environments"}
            iconTitle={"data"}
            resources={resources?.executionEnvironments}
            excludedResources={excludedResources}
            isRecap={true}
          />
          <View
            style={{
              height: 1,
              backgroundColor: currentTheme?.theme?.mediumGrey,
              marginVertical: 10,
            }}
          />
        </>
      )}
      {resources?.functions?.length > 0 && (
        <QaHiringResourcesLeaf
          title={"Functions"}
          iconTitle={"functions"}
          resources={resources?.functions}
          excludedResources={excludedResources}
          isRecap={true}
        />
      )}

      <AppForms.AppSubmitButton
        title={"Confirm"}
        //   isDisabled={fileMetaDataSavingInProgress}
        awesomeIconColor={currentTheme?.theme?.white}
        backgroundColor={currentTheme?.theme?.primary}
        btnContentStyle={{
          paddingLeft: 0,
          paddingRight: 0,
        }}
        style={[
          {
            height: Constants.appButtonHeight,
            width: "auto",
            shadowColor: currentTheme?.theme?.transparent,
            marginHorizontal: 10,
          },
        ]}
        // btnLabelStyle={{ fontSize: 16 }}
        wrapperStyle={[
          {
            margin: 10,
            width: "fit-content",
            minWidth: 150,
            alignSelf: "center",
            height: Constants.appButtonHeight,
          },
        ]}
      />
    </View>,
  ];
  if (fields)
    return (
      <>
        {isLoading ? (
          <ToothFairyLoadingPlaceholder caption="Loading..." />
        ) : (
          <AppSlider
            onIndicatorClick={handleIndicatorClick}
            // Functionality disabled as refactoring needed to check whether the related field in the slider is filled in
            // This is needed for the onboarding specifically
            isIndicatorComponentClickableToMoveForward={true}
            index={sliderIndex}
            items={sliderItems}

            // styleSliderWrapper={styles.sliderWrapper}
            // styleIndicatorWrapper={styles.indicatorWrapper}
          ></AppSlider>
        )}
      </>
    );
  else return <>No Form Fields</>;
};

export default QaHiringTemplateView;
